import { LuBadgePercent } from "react-icons/lu";
import { PiSealPercentThin } from "react-icons/pi";

const EmptyData = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen text-center text-gray-500">
      <PiSealPercentThin size={48} />
      <p className="mt-4 text-lg">Currently, there are no rewards available for use.</p>
    </div>
  );
};

export default EmptyData;